// Income Type Getters

export const getIncomeTypeList = state => {
  return state.incomeTypeList
}

export const getIncomeTypeInfo = state => {
  return state.incomeTypeInfo
}

export const getFullIncomeTypesList = state => {
  return state.fullIncomeTypesList
}
